<template>
    <div id="app">
        <v-app>
            <template v-if="$route.path==='/login' || $route.path==='/'">
                <router-view></router-view>
            </template>
            <template v-else>
                <v-app-bar app clipped-right class="elevation-0 white" fixed>
                    <v-icon @click.stop="drawer = !drawer">mdi-menu</v-icon>
                    <div class="pl-1 pt-2"><img alt="" src="../src/assets/logo.png" style="width: 70px">
                        <span class="pl-3 headline"
                              style="position: absolute; top: 15px">Raj Wafers</span>
                    </div>
                    <v-spacer></v-spacer>
                    <div class="d-flex align-center mr-5">
                        <v-avatar class="mr-3" color="grey lighten-3" size="36">
                            <v-icon size="20">mdi-account</v-icon>
                        </v-avatar>
                        <div>
                            <h4 class="font-weight-medium">{{user&&user.organization?user.organization.name:''}}</h4>
                            <h5 class="font-weight-regular grey--text text--darken-1">{{user?user.name:''}}</h5>
                        </div>
                    </div>
                    <v-tooltip nudge-bottom="50" nudge-right="150" left>
                        <template v-slot:activator="{ on }">
                            <v-btn @click.prevent="openDialog" class="error--text" icon v-on="on">
                                <v-icon>mdi-power-standby</v-icon>
                            </v-btn>
                        </template>
                        <span>Logout</span>
                    </v-tooltip>
                </v-app-bar>
                <v-navigation-drawer @keydown.esc="drawer=false" absolute app clipped temporary v-model="drawer">
                    <v-list class="text-left" shaped>
                        <v-list-item :key="index" :to="{path: menuItem.to}"
                                     v-for="(menuItem,index) in constants.menuItems">
                            <v-list-item-icon>
                                <v-icon>{{menuItem.icon}}</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="menuItem.name"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                    </v-list>
                </v-navigation-drawer>
                <v-main>
                    <router-view></router-view>
                </v-main>
            </template>
        </v-app>
        <ConfirmationDialog :confirmationMessage="confirmMsg" @close="confirmationDialog=false"
                            @confirm="logout" v-if="confirmationDialog"></ConfirmationDialog>
    </div>
</template>
<script>
    // import NetworkCommunicator from './plugins/NetworkResourceHandler'
    import ConfirmationDialog from './components/Common/ConfirmationDialog'
    import Constants from './Constants/Constants'
    import {GET_PACKAGE_SETTINGS} from "./graphql/queries/Settings";

    export default {
        components: {ConfirmationDialog},
        apollo:{
            packageSettings:{
                query: GET_PACKAGE_SETTINGS,
                fetchPolicy: 'network-only',
                skip () {return this.$route.path === '/login'},
                result ({data}) {localStorage.setItem('packageColor', JSON.stringify(data.packageSettings[0].value)) }
            },
        },
        data() {
            return {
                constants: Constants,
                confirmationDialog: false,
                confirmMsg: '',
                toaster: {},
                drawer: false,
                loading: false,
                user: localStorage.user ? JSON.parse(localStorage.user) : null
            }
        },
        methods: {
            openDialog() {
                this.confirmMsg = 'Are you sure, You want to logout ?'
                this.confirmationDialog = true
            },
            async logout() {
                this.loading = true
                // let response = await NetworkCommunicator('GET', `${this.constants.api_url}logout`)
                // if (response.flag) {
                localStorage.clear()
                this.confirmationDialog = false
                this.$router.push('/login')
                this.loading = false
                // } else {
                //   this.toaster = { enable: true, color: 'red', message: response.message }
                //   this.loading = false
                // }
            },
        },
    }
</script>
<style>
    body{
      font-family: 'Open Sans', sans-serif;
    }
    #app {
      font-family: 'Open Sans', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        color: #2c3e50;
    }

    .success-toast.toasted.primary {
        background-color: #2c9d28 !important;
        color: #ffffff;
        height: 30px !important;
    }

    .error-toast.toasted.primary {
        height: 30px !important;
        color: #ffffff;
        background-color: #d61c16 !important;
    }

    ::-webkit-scrollbar {
      width: 5px !important;
      height: 5px !important;
      display: block !important;
    }

    ::-webkit-scrollbar-thumb {
      background: #c8c8c8 !important;
      border-radius: 5px !important;
    }
</style>
<style scoped>
    /deep/.theme--light.v-text-field--outlined:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot fieldset{
        color: rgba(0,0,0,.14);
    }
</style>
